import Step from "../../components/step/Step";
import { Box, SimpleGrid, Text, useRadioGroup } from "@chakra-ui/react";
import RadioCard from "../../components/radio-card/RadioCard";
import { useNavigate } from "react-router-dom";
import { translation } from "../../utils/translation";

function Step9() {
  let navigate = useNavigate();

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "q9",
    onChange: () => {
      navigate("../step11", { replace: true });
    },
  });

  const options = [
    {
      id: "a1",
      text: translation("general.step9.option1"),
    },
    {
      id: "a2",
      text: translation("general.step9.option2"),
    },
    {
      id: "a3",
      text: translation("general.step9.option3"),
    },
    {
      id: "a4",
      text: translation("general.step9.option4"),
    },
  ];

  const group = getRootProps();

  return (
    <Step
      heading={translation("general.step9.headline")}
      currentStep={7}
      backLink={"/step8"}
    >
      <SimpleGrid mt={5} spacing={2} columns={1} {...group}>
        {options.map((value) => {
          const radio = getRadioProps({ value: value.id });
          return (
            <RadioCard key={value.id} {...radio}>
              <Box display={"flex"} alignItems={"center"}>
                <Text fontSize={"lg"} fontWeight={"bold"}>
                  {value.text}
                </Text>
              </Box>
            </RadioCard>
          );
        })}
      </SimpleGrid>
    </Step>
  );
}

export default Step9;
